import { endpoint } from "views/pages/manage/common/constant";
import { dropdownMapping } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { updateRequest } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import moment from "moment";
import { fetchDeletePromisedData } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { fetchAllPostPromisedData } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";

export const FILTER__FORM_FIELDS_GLOBAL = {
    businessArea: "",
    career: "",
    searchByValue: "",
    status: false,
}

export const getDropdowns = async () => {
    const dropdown = await Promise.all([
        dropdownMapping(
            endpoint.academic_career.getAllActive,
            "academicCareerDispValue",
            "academicCareerDispValue"
        ),
        dropdownMapping(
            endpoint.groupCode.getAllActive,
            "groupCodeDispValue",
            "groupCodeDispValue"
        ),
        dropdownMapping(
            endpoint.companyCode.getAllActive,
            "companyCodeDispValue",
            "companyCodeDispValue"
        ),
        dropdownMapping(
            endpoint.businessArea.getAllActiveV2,
            "businessAreaDispValue",
            "businessAreaDispValue",
            "businessAreaDesc"
        ),
        dropdownMapping(
            endpoint.term.getAllActive,
            "termDispValue",
            "termDispValue"
        ),
        dropdownMapping(
            endpoint.programAction.getAllActive,
            "programActionKey",
            "programActionKey",
        ),
    ])
    return {
        career: dropdown[0],
        businessGrp: dropdown[1],
        companyCode: dropdown[2],
        businessArea: dropdown[3],
        term: dropdown[4],
        programActions: dropdown[5]
    };
}

export const newRow = {
    businessGrp: "",
    companyCode: "",
    career: "",
    term: "",
    programAction: "",
    cycleName: "",
    triggerDays: "",
    eligibleRange: {},
    businessArea: "",
    status: "ACTIVE",
}

export const getUpdatedData = (resp, dropdowns) => {
    const updatedData = resp?.data?.paginatedData?.map(({
        businessGrp,
        businessArea,
        companyCode,
        branchType,
        career,
        programAction,
        term,
        triggerDays,
        eligibleRange,
        ...rest
    }) => ({
        ...rest,
        businessGrp: dropdowns?.businessGrp?.find(bg => bg?.label == businessGrp),
        businessArea: dropdowns?.businessArea?.find(bu => bu?.label == businessArea),
        companyCode: dropdowns?.companyCode?.find(co => co?.label == companyCode),
        branchType: dropdowns?.branchType?.find(bt => bt?.label == branchType),
        career: dropdowns?.career?.find(ac => ac?.label == career),
        programAction: dropdowns?.programAction?.find(p => p?.label == programAction),
        term: dropdowns?.term?.find(t => t?.label == term),
        // ✅ convert "1,5,10,15" → [1,5,10,15]
        triggerDays: typeof triggerDays === "string"
            ? triggerDays.split(",").map(num => Number(num))
            : [],

        // ✅ convert "1-15" → { start: 1, end: 15 }
        eligibleRange: typeof eligibleRange === "string"
            ? {
                start: Number(eligibleRange.split("-")[0]),
                end: Number(eligibleRange.split("-")[1])
            }
            : {}
    }));
    return updatedData;
}

export const getCreateUpdateReqBody = (rowData, isBranchLevelConfig) => {
    const { businessArea, eligibleRange } = rowData;
    const row = updateRequest(rowData);
    const { businessGrp, companyCode, career, branchType, programAction, term, status, cycleName, triggerDays } = row;
    return {
        businessGrp,
        businessArea: isBranchLevelConfig ? businessArea?.label : "ALL",
        companyCode,
        career,
        branchType,
        programAction,
        term,
        cycleName,
        triggerDays: triggerDays,
        startDay: eligibleRange?.start,
        endDay: eligibleRange?.end,
        status
    }
}

export const getConfigs = async (reqObj, pageNumber, pageSize) => {
    return await fetchAllPostPromisedData(`${endpoint?.disc?.parentFeebackConfig?.search}?&offset=${pageNumber}&pageSize=${pageSize}`,
        reqObj,
        "post");
}


export const deleteConfig = async (id) => {
    let resp = await fetchDeletePromisedData(`${endpoint?.disc?.parentFeebackConfig?.delete}/${id}`)
    if (resp?.code === 200) {
        return true;
    } else {
        return false;
    }
}